import { StatelessComponent } from 'react'
import { connect } from 'react-redux'
import * as styles from 'components/features/pfm/NotificationTray/NotificationTray.css'
import { TrackerNotification } from 'interfaces/notifications'
import { MoneyflowType } from 'interfaces/moneyflow'
import { CategoryId } from 'interfaces/meta'
import { AnchorPlacement } from 'interfaces/navigation'
import { toggleMoneyflowTrackerDetailsActionCreator } from 'actions/moneyflowActions'
import { dismissNotificationActionCreator } from 'actions/notificationsActions'
import Icon from 'components/atoms/Icon'
import InsightButton, { NoLink } from 'components/features/insights/InsightButton/InsightButton'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'

type TrackerNotificationItemOwnProps = {
  notification: TrackerNotification
}

type TrackerNotificationItemDispatchProps = {
  toggleTracker: (type: MoneyflowType, categoryId: CategoryId) => void
  dismissNotification: (id: string) => void
}

type TrackerNotificationItemProps = TrackerNotificationItemDispatchProps & TrackerNotificationItemOwnProps

const TrackerNotificationItemComponent: StatelessComponent<TrackerNotificationItemProps> = (props) => {
  const {
    notification,
    dismissNotification, toggleTracker,
  } = props
  const { creationData, icon, text } = notification
  const anchorPlacement: AnchorPlacement = creationData.type === 'spending'
    ? 'dashboard_spending-trackers'
    : 'dashboard_income-trackers'

  return (
    <div className={ styles.itemInner }>
      { icon && (
        <div className={ styles.icon }>
          <Icon kind={ icon } />
        </div>
      )}
      <section className={ styles.itemContent }>
        <section className={ styles.itemText }>
          { text }
        </section>
        <section className={ styles.buttons }>
          <InsightButton
            linkComponent={ NavigationLink }
            to={ anchorPlacement }
            theme='text-only'
            onClick={ () => toggleTracker(creationData.type, creationData.category.id) }
          >
            View Tracker
          </InsightButton>
          <InsightButton
            linkComponent={ NoLink }
            theme='text-only'
            onClick={ () => dismissNotification(notification.id) }
          >
            Dismiss
          </InsightButton>
        </section>
      </section>
    </div>
  )
}

const mapDispatchToProps: TrackerNotificationItemDispatchProps = {
  toggleTracker: toggleMoneyflowTrackerDetailsActionCreator,
  dismissNotification: dismissNotificationActionCreator,
}

export const TrackerNotificationItem = connect<
  {},
  TrackerNotificationItemDispatchProps,
  TrackerNotificationItemOwnProps
>(undefined, mapDispatchToProps)(TrackerNotificationItemComponent)
